<template>
  <div>
    <div v-if="itens.length" class="table-responsive">
      <table class="table table-sm">
        <caption class="sr-only">Itens de atendimento, sem soma entre etapas ou segmentos</caption>
        <thead>
          <tr><th scope="col">Item</th><th scope="col">Quantidade</th><th scope="col">Quantidade confirmada</th><th scope="col">Valor unitário</th><th scope="col">STATUS</th></tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in itens" :key="item.id || item.externalLineKey || index">
            <td>{{ informado(item.codigoItem) }}</td>
            <td>{{ informado(item.quantidade) }}</td>
            <td>{{ informado(item.quantidadeConfirmada) }}</td>
            <td>{{ moeda(item.valorUnitario) }}</td>
            <td>{{ informado(item.situacaoMac) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p v-else>Nenhum item informado.</p>
  </div>
</template>

<script>
export default {
  props: { itens: { type: Array, default: () => [] } },
  methods: {
    informado(valor) { return valor == null || valor === '' ? 'Não informado' : valor; },
    moeda(valor) {
      return valor == null || valor === '' || !Number.isFinite(Number(valor))
        ? 'Não informado' : Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
  },
};
</script>